<template>
    <v-card flat>
        <v-card-text>
            <v-row>
                <v-col cols="12">
                    <v-textarea
                        type="text"
                        v-model="rav.name"
                        :label="$t('rav.name')"
                        :error-messages="formError(errors, 'name')"
                        :hint="$t('general.required')"
                        persistent-hint
                    />
                </v-col>
                <v-col cols="12">
                    <v-textarea
                        type="text"
                        v-model="rav.address"
                        :label="$t('rav.address')"
                        :error-messages="formError(errors, 'address')"
                    />
                </v-col>
                <v-col cols="12">
                    <v-autocomplete
                        :items="cantonsItems"
                        :label="$t('rav.canton')"
                        v-model="rav.canton.code"
                        :error-messages="formError(errors, 'canton')"
                        :hint="$t('general.required')"
                        persistent-hint
                    />
                </v-col>
                <v-col cols="6">
                    <v-text-field
                        type="text"
                        v-model="rav.zip"
                        :label="$t('rav.zip')"
                        :error-messages="formError(errors, 'zip')"
                    />
                </v-col>
                <v-col cols="6">
                    <v-text-field
                        type="text"
                        v-model="rav.city"
                        :label="$t('rav.city')"
                        :error-messages="formError(errors, 'city')"
                        :hint="$t('general.required')"
                        persistent-hint
                    />
                </v-col>
                <v-col cols="12">
                    <v-text-field
                        type="text"
                        v-model="rav.phone"
                        :label="$t('rav.phone')"
                        :error-messages="formError(errors, 'phone')"
                    />
                </v-col>
                <v-col cols="12">
                    <v-text-field
                        type="text"
                        v-model="rav.fax"
                        :label="$t('rav.fax')"
                        :error-messages="formError(errors, 'fax')"
                    />
                </v-col>
                <v-col cols="12">
                    <v-text-field
                        type="text"
                        v-model="rav.email"
                        :label="$t('rav.email')"
                        :error-messages="formError(errors, 'email')"
                    />
                </v-col>
                <v-col cols="12">
                    <v-text-field
                        type="text"
                        v-model="rav.website"
                        :label="$t('rav.website')"
                        :error-messages="formError(errors, 'website')"
                    />
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
    name: 'RavInformation',
    props: {
        rav: {
            type: Object,
            default: () => ({
                name: '',
                roles: [],
            }),
        },
        errors: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        ...mapGetters({
            cantons: 'canton/cantons',
        }),
        cantonsItems() {
            const allCantons = [];
            for (let i = 0; i < this.cantons.length; i++) {
                const canton = this.cantons[ i ];
                allCantons.push({
                    value: canton.code,
                    text: `${canton.code} ${canton.name}`,
                })
            }
            return allCantons;
        },
    },
};
</script>
